var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalAju",
    attrs: {
      "id": "modal-aju",
      "title": "Aju Baru",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addAju($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Aju"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jenis Aju') ? 'is-invalid' : '',
    attrs: {
      "name": "Jenis Aju",
      "options": [{
          text: 'Jenis Pengajuan',
          value: ''
        },
        {
          text: 'Barang Pindahan',
          value: 1
        },
        {
          text: 'Kendaraan Bermotor',
          value: 2
        }
      ]
    },
    model: {
      value: (_vm.jenis_aju),
      callback: function($$v) {
        _vm.jenis_aju = $$v
      },
      expression: "jenis_aju"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Aju')),
      expression: "errors.has('Jenis Aju')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Aju')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama Pemohon"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Nama Pemohon') ? 'is-invalid' : '',
    attrs: {
      "name": "Nama Pemohon",
      "type": "text"
    },
    model: {
      value: (_vm.nama_penerima),
      callback: function($$v) {
        _vm.nama_penerima = $$v
      },
      expression: "nama_penerima"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Pemohon')),
      expression: "errors.has('Nama Pemohon')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nama Pemohon')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Identitas"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Identitas') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.ref_identitas,
      "option-value": "kd_id",
      "option-text": "URAIAN",
      "name": "Jenis Identitas",
      "placeholder": "Jenis Identitas"
    },
    model: {
      value: (_vm.jenis_identitas_penerima),
      callback: function($$v) {
        _vm.jenis_identitas_penerima = $$v
      },
      expression: "jenis_identitas_penerima"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Identitas')),
      expression: "errors.has('Jenis Identitas')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Identitas')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Identitas"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.jenis_identitas_penerima === '5' ? 'required|min:16' : 'required'),
      expression: " jenis_identitas_penerima === '5' ? 'required|min:16' : 'required' "
    }],
    class: _vm.errors.has('Nomor Identitas') ? 'is-invalid' : '',
    attrs: {
      "name": "Nomor Identitas",
      "type": "text"
    },
    model: {
      value: (_vm.no_identitas_penerima),
      callback: function($$v) {
        _vm.no_identitas_penerima = $$v
      },
      expression: "no_identitas_penerima"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Identitas')),
      expression: "errors.has('Nomor Identitas')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Identitas')))])], 1), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Buat Aju\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edae08a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalAju.vue
// module id = 337
// module chunks = 0